import React from 'react';
import { Helmet } from 'react-helmet';
import { SEMANTIC_HR_FAQ, semanticHrFaqPlainText } from '../../../../content/enterpriseMessaging';

function Answer({ item }) {
  if (!item.leadLink) {
    return <p className="mt-2 text-base leading-relaxed text-ink-600">{item.answer}</p>;
  }

  return (
    <p className="mt-2 text-base leading-relaxed text-ink-600">
      <a
        href={item.leadLink.href}
        className="font-medium text-brand-600 hover:text-brand-700"
      >
        {item.leadLink.label}
      </a>
      {item.answer}
      {item.sourceLink ? (
        <>
          {' Source: '}
          <a
            href={item.sourceLink.href}
            className="font-medium text-brand-600 hover:text-brand-700"
          >
            {item.sourceLink.label}
          </a>
          .
        </>
      ) : null}
    </p>
  );
}

export default function Faq() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: SEMANTIC_HR_FAQ.items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: semanticHrFaqPlainText(item),
      },
    })),
  };

  return (
    <section id="faq" className="py-16 md:py-20 scroll-mt-24">
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      </Helmet>
      <div className="container-x">
        <div className="max-w-3xl">
          <p className="eyebrow">{SEMANTIC_HR_FAQ.eyebrow}</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
            {SEMANTIC_HR_FAQ.title}
          </h2>
        </div>
        <dl className="mt-10 max-w-3xl divide-y divide-ink-200 border-y border-ink-200">
          {SEMANTIC_HR_FAQ.items.map((item) => (
            <div key={item.question} className="py-6">
              <dt className="text-base font-semibold text-ink-900">{item.question}</dt>
              <dd>
                <Answer item={item} />
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}
